var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJunction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Junction") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plaza_Load-schedule",
    transform: "translate(-342.000000, -508.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Outlet_96136",
    transform: "translate(342.000000, 508.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8293849,4.64442128 L20,4.64442128 L20,6.31695649 L18.5372731,6.31695649 C18.7947207,7.15384706 18.9333333,8.04307355 18.9333333,8.96478873 C18.9333333,13.6324911 15.3785304,17.4670014 10.8375,17.8906998 L10.8375,19 L9.17083333,19 L9.17083333,17.8914734 C4.62581931,17.4716916 1.06666667,13.635346 1.06666667,8.96478873 C1.06666667,8.04307355 1.20527926,7.15384706 1.46272687,6.31695649 L0,6.31695649 L0,4.64442128 L2.17061509,4.64442128 C3.69094419,1.87574015 6.6271894,0 10,0 C13.3728106,0 16.3090558,1.87574015 17.8293849,4.64442128 Z M10.8375,16.276477 C14.4931974,15.8594015 17.3333333,12.7449376 17.3333333,8.96478873 C17.3333333,8.03100032 17.1600255,7.13783266 16.8439275,6.31591096 L14.0270832,6.31591096 L14.0270832,7.22221604 L11.5270832,7.22221604 L11.5270832,3.7381162 L14.0270832,3.7381162 L14.0270832,4.64442128 L15.9372246,4.64442128 C14.6043256,2.80296296 12.4414978,1.6056338 10,1.6056338 C7.55850219,1.6056338 5.39567436,2.80296296 4.06277543,4.64442128 L5.9729168,4.64442128 L5.9729168,3.7381162 L8.4729168,3.7381162 L8.4729168,7.22326158 L5.9729168,7.22326158 L5.9729168,6.31695649 L3.15567052,6.31695649 C2.8398276,7.13859008 2.66666667,8.03139625 2.66666667,8.96478873 C2.66666667,12.7478095 5.51111969,15.8641333 9.17083333,16.2774229 L9.17083333,13.0070973 L8.26770827,13.0070973 C8.26770827,13.0070973 7.95520827,10.497249 10.0729168,10.497249 C11.9656251,10.497249 11.7395835,13.0060518 11.7395835,13.0060518 L10.8375,13.0060518 L10.8375,16.276477 Z",
    id: "Junction"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJunction);
export default __webpack_public_path__ + "static/media/Junction.dee3c14388cc042ab56eadc73c734585.svg";
export { ForwardRef as ReactComponent };